import { render, staticRenderFns } from "./health-score-components.vue?vue&type=template&id=e5f9af5e&"
import script from "./health-score-components.vue?vue&type=script&lang=js&"
export * from "./health-score-components.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports